import type { FormErrors, FormState, OriginalValues } from "@app/dashboard/types/innerLayout/business_profile";

export const MAX_BUSINESS_DESCRIPTION_LENGTH = 500;
export const MAX_LOGO_SIZE = 1; // 1MB
export const MIN_LOGO_DIMENSION = 64; // 64px
export const DEFAULT_WHATSAPP_COUNTRY = "eg";

export const EMPTY_FORM_STATE: FormState = {
  businessName: "",
  businessDescription: "",
  logoImage: null,
  accountType: "",
  sector: "",
  industry: "",
  website: "",
  facebook: "",
  instagram: "",
  whatsappPhone: "",
  whatsappCountry: DEFAULT_WHATSAPP_COUNTRY,
};

export const EMPTY_ORIGINAL_VALUES: OriginalValues = {
  ...EMPTY_FORM_STATE,
  originalLogoUrl: null,
};

export const EMPTY_FORM_ERRORS: FormErrors = {
  website: "",
  facebook: "",
  instagram: "",
  businessDescription: "",
  whatsappPhone: "",
};
